export const Devices = {
  ALL_DEVICES: 'allDevices',
  ANDROID: 'android',
  IOS: 'ios',
};
